var exports = {
  "qB": "containerReadonly__MQ17xb",
  "CO": "containerEditable__BSrBU8",
  "$F": "SectionHeaderTitle__dackeX",
  "JR": "headingReadonly__Oqs48-",
  "xc": "headingEditable__aIPlvB",
  "r9": "editButton__oqyFBm",
  "Jq": "screenReaderText__Nu5VG7",
};

module.exports = exports;
